var exports = {
  "kL": "container___YtJgp",
  "wx": "header__Jp4Uo6",
  "pz": "sidebar__QFB4pD",
  "Dd": "toggleSidebarFloating__z8ITrI",
  "vP": "toggleSidebarVertical__ZDSdwA",
  "iw": "sidebarDivider__XKqX1y",
  "lo": "githubLogo__vsLNxA",
  "RK": "visible__i6Ykhn",
  "Av": "isExpanded__os5spt",
};

module.exports = exports;
